import axios, {} from 'axios';
import { validateEnv } from '../utils/validateEnv.js';
const { AXIZ_DIGITAL_API } = validateEnv();
// Create Axios Client
export const axiosClient = axios.create({
    baseURL: AXIZ_DIGITAL_API,
    headers: { 'Content-Type': 'application/json' },
    timeout: 10000, // 10 seconds timeout
});
/**
 * Request Interceptor: Attach Authorization Token
 */
// Use extracted handlers for request interceptor
import { requestHandler, responseHandler } from './axiosClientHandlers.js';
axiosClient.interceptors.request.use(requestHandler, (error) => Promise.reject(error instanceof Error ? error : new Error(String(error))));
/**
 * Response Interceptor: Handle token expiration & errors
 */
// Use extracted handlers for response interceptor
axiosClient.interceptors.response.use((response) => response, responseHandler);
//# sourceMappingURL=axiosClient.js.map